var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalFan1Staged = function SvgDAhuSignalFan1Staged(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 105,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,95c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S218.5,95,224,95 M224,94c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S230.1,94,224,94L224,94z",
    fill: "#1C9D5B"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "222.5,109 222.5,105.1 226.4,105.1 226.4,101.2 229.9,101.2 229.9,100.2 225.4,100.2 225.4,104.1 221.5,104.1 221.5,108 218.6,108 218.6,98.7 217.6,98.7 217.6,111 229.9,111 229.9,110 218.6,110 218.6,109"
  })))));
};
export default SvgDAhuSignalFan1Staged;